import React from "react";
import { CheckCircle2 } from "lucide-react";

// Iteration 282/283 — shared cash-out status pill for every kid-facing
// transfer surface (Kid Zone Transfers tab + My passbook). Paid rows
// render a green checkmarked "Paid in Cash" / "Paid to Bank" badge;
// approved-but-unpaid rows stay "Held by Parent" (money is sitting in
// the household account).
export const transferStatusClass = (r) => {
  if (r.status === "approved") {
    return r.payout_status === "paid"
      ? "bg-emerald-100 text-emerald-800 border-emerald-200"
      : "bg-sky-100 text-sky-800 border-sky-200";
  }
  if (r.status === "declined") return "bg-rose-100 text-rose-800 border-rose-200";
  return "bg-amber-100 text-amber-900 border-amber-200";
};

export const transferStatusLabel = (r) =>
  r.status === "approved"
    ? (r.payout_status === "paid" ? (r.payout_method === "bank" ? "Paid to Bank" : "Paid in Cash") : "Held by Parent")
    : r.status === "declined" ? "Declined" : "Pending Approval";

export default function TransferStatusPill({ row, testid }) {
  const paid = row.status === "approved" && row.payout_status === "paid";
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold uppercase tracking-wider ${transferStatusClass(row)}`} data-testid={testid}>
      {paid && <CheckCircle2 className="w-3 h-3 mr-0.5" />}
      {transferStatusLabel(row)}
    </span>
  );
}
